import BApp from "./BApp";

export default class BModal
{
	constructor(el)
	{
		this.el = el;

		if (!this.el.dataset.BModalInitd) {
			this.addEventListeners();
			this.el.dataset.BModalInitd = 1;
		}
	}

	addEventListeners()
	{
		document.addEventListener("keyup", event => {
			if (event.key === "Escape") {
				BModal.closeAll();
			}
		});

		document.addEventListener("click", event => {
			if (event.target.tagName == "HTML" || event.target.matches(".modal") || event.target.matches(".modal__close-button")) {
				BModal.closeAll();
			}
		});
	}

	open()
	{
		document.querySelector("body").classList.add("noscroll");

		let clonedModal = this.el.cloneNode(true);
		this.el.parentElement.append(clonedModal);
		clonedModal.classList.add("modal--visible");
		BApp.refresh();

		try {
			clonedModal.querySelector(".focus:visible").focus();
		} catch (error) {
			// Nevermind.
		}
	};

	close()
	{
		document.querySelector("body").classList.remove("noscroll");
		this.el.remove();
	}

	static closeAll()
	{
		document.querySelector("body").classList.remove("noscroll");
		document.querySelectorAll(".modal--visible").forEach(el => {
			(new BModal(el)).close();
		});
	}
}
